import * as PROJECT_API from '@/api/project/index'

export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    getProject (commit, projectId) {
      return PROJECT_API.getProject(projectId).then((resp) => {
        return resp
      })
    }
  }
}
